var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{ref:"modal",staticClass:"success-promo-modal",attrs:{"visible":_vm.show},on:{"update:visible":function($event){return _vm.$emit('update:show', false)}}},[_c('div',{staticClass:"success-promo"},[_c('h1',[_vm._v("Great 🎉")]),_c('h2',[_vm._v("Your signature successfully copied!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }